import React, { useEffect, useState, ChangeEvent } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { NameDevSetModel } from './ReadDevCsvDialog';

type ReadDevCsvDialogGridRowProps = {
  nameDevRow: NameDevSetModel;
  onChangeData: (targetRow: NameDevSetModel) => void;
  bodyCellStyle: string;
  textFieldStyle: string;
};

const ReadDevCsvDialogGridRow: React.FC<ReadDevCsvDialogGridRowProps> = (props) => {
  const [nameDevRow, setNameDevRow] = useState<NameDevSetModel>(props.nameDevRow); //データ初期値
  const [isEdit, setIsEdit] = useState<boolean>(false); //変更フラグ データを編集したらtrue

  /**
   * データ変更通知
   */
  useEffect(() => {
    //データ初期値にセットされている内容を再描画時に変えたい場合、useEffectが必要
    setNameDevRow({ ...props.nameDevRow });
    setIsEdit(false);
  }, [props.nameDevRow]);

  /**
   * 値を変更した内容を管理
   * @param key
   * @returns
   */
  const onChangeCell = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    console.debug(['onChangeCell - key', key]);
    setIsEdit(true);
    setNameDevRow({ ...nameDevRow, [key]: event.target.value });
  };

  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: NameDevSetModel, editFlg: boolean) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (editFlg) {
      props.onChangeData(editRow);
    }
  };

  return (
    <>
      <TableRow key={nameDevRow.indexNo}>
        <TableCell className={props.bodyCellStyle}>{nameDevRow.indexNo}</TableCell>
        <TableCell className={props.bodyCellStyle}>
          <input
            className={props.textFieldStyle}
            type="text"
            maxLength={255}
            //defaultValue={nameDevRow.DevNo}
            value={nameDevRow.DevNo}
            onChange={onChangeCell('DevNo')}
            onBlur={onChangeData(nameDevRow, isEdit)}
          />
        </TableCell>
        <TableCell className={props.bodyCellStyle}>
          <input
            className={props.textFieldStyle}
            type="text"
            maxLength={255}
            //defaultValue={nameDevRow.DevName}
            value={nameDevRow.DevName}
            onChange={onChangeCell('DevName')}
            onBlur={onChangeData(nameDevRow, isEdit)}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default ReadDevCsvDialogGridRow;
